import Vuex from "vuex";
import Vue from "vue";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {
        step: localStorage.getItem('step') || 1,
        namesResponseData: JSON.parse(localStorage.getItem('namesResponseData')) || [],
        step1RequestData: JSON.parse(localStorage.getItem('step1Request')) || [],
        descriptionsResponseData: JSON.parse(localStorage.getItem('descriptionsResponseData')) || [],
        currentTitle: JSON.parse(localStorage.getItem('currentTitle')) || {},
    },
    mutations: {
        SET_STEP(state, step) {
            state.step = step;
            localStorage.setItem('step', step);
        },
        SET_NAMES_RESPONSE_DATA(state, data) {
            state.namesResponseData = data;
            localStorage.setItem('namesResponseData', JSON.stringify(data));
        },
        SET_STEP1_REQUEST_DATA(state, data) {
            state.step1RequestData = data;
            localStorage.setItem('step1RequestData', JSON.stringify(data));
        },
        SET_DESCRIPTIONS_RESPONSE_DATA(state, data) {
            state.descriptionsResponseData = data;
            localStorage.setItem('descriptionsResponseData', JSON.stringify(data));
        },
        SET_CURRENT_TITLE(state, data) {
            state.currentTitle = data;
            localStorage.setItem('currentTitle', JSON.stringify(data));
        },
        UPDATE_DESCRIPTIONS(state, descriptions) {
            state.descriptionsResponseData = descriptions;
            localStorage.setItem("descriptionsResponseData", JSON.stringify(descriptions));
        },
        CLEAR_STORAGE_DATA() {
            const keysToRemove = ['namesResponseData', 'descriptionsResponseData', 'currentTitle', 'step'];
            keysToRemove.forEach(key => localStorage.removeItem(key));
        }
    },
    actions: {
        changeStep({ commit }, step) {
            commit('SET_STEP', step);
            // if(step == 1) {
            //     window.location.reload();
            // }

            // const url = new URL(window.location);
            // url.searchParams.set('step', step);
            // window.history.pushState({}, '', url);
        },
        saveNamesResponseData({ commit }, data) {
            commit('SET_NAMES_RESPONSE_DATA', data);
        },
        saveStep1RequestData({ commit }, data) {
            commit('SET_STEP1_REQUEST_DATA', data);
        },
        saveDescriptionsResponseData({ commit }, data) {
            commit('SET_DESCRIPTIONS_RESPONSE_DATA', data);
        },
        setCurrentTitle({ commit }, data) {
            commit('SET_CURRENT_TITLE', data);
        },
        updateDescriptions({ commit }, descriptions) {
            localStorage.setItem("descriptionsResponseData", JSON.stringify(descriptions));

            commit("UPDATE_DESCRIPTIONS", descriptions);
        },

        clearStorageData({commit}) {
            commit('CLEAR_STORAGE_DATA');
        },

        async generateDescription({ commit , dispatch}, data) {
            let name = data.name;
            let index = data.index;

            $('.ai-loader').addClass('show');
            const startTime = Date.now();

            axios.post("/idea-generator/prompt/descriptions", { name })
                .then(response => {
                    if (response.data.success) {
                        commit("SET_DESCRIPTIONS_RESPONSE_DATA", response.data.results);
                        commit("SET_CURRENT_TITLE", {name, index});
                        dispatch('changeStep', 3);
                    } else {
                        toastr.danger("Something went wrong, please try again later");
                    }

                })
                .catch(()=> {
                    toastr.danger("Something went wrong, please try again later");
                })
                .finally(() => {
                    const elapsedTime = Date.now() - startTime;
                    const remainingTime = Math.max(4000 - elapsedTime, 0);

                    setTimeout(() => {
                        $('.ai-loader').removeClass('show');
                    }, remainingTime);
                });
        },
    },
    getters: {
        step: state => state.step,
        namesResponseData: state => state.namesResponseData,
        step1RequestData: state => state.step1RequestData,
        descriptionsResponseData: state => state.descriptionsResponseData,
        currentTitle: state => state.currentTitle,
    }
})

export default store;
